import React, { FC } from 'react';
import { TimelineConnector, TimelineDot, TimelineSeparator } from '@material-ui/lab';
import { HistorySnapshotComponent } from './serialNumbers';
import AddIcon from '@material-ui/icons/Add';
import LoopIcon from '@material-ui/icons/Loop';
import RemoveIcon from '@material-ui/icons/Remove';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import { makeStyles } from '@material-ui/core/styles';

const usesStyles = makeStyles((theme) => ({
    primaryTail: {
        backgroundColor: theme.palette.primary.main
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main
    }
}));

export const SerialNumberHistorySeparator: FC<{components: HistorySnapshotComponent[]}> = ({ components }) => {
    const classes = usesStyles();

    let action = (components.length == 1) ? components[0].action : "";

    switch (action) {
        case "add":
            return (
                <TimelineSeparator>
                    <TimelineDot variant="outlined" color="primary">
                        <AddIcon color="primary" />
                    </TimelineDot>
                    <TimelineConnector className={classes.primaryTail} />
                </TimelineSeparator>
            )
        case "remove":
            return (
                <TimelineSeparator>
                    <TimelineDot variant="outlined" color="secondary">
                        <RemoveIcon color="secondary" />
                    </TimelineDot>
                    <TimelineConnector className={classes.secondaryTail} />
                </TimelineSeparator>
            )
        case "update":
            return (
                <TimelineSeparator>
                    <TimelineDot variant="outlined">
                        <LoopIcon />
                    </TimelineDot>
                    <TimelineConnector className={classes.secondaryTail} />
                </TimelineSeparator>
            )
        default:
            return (
                <TimelineSeparator>
                    <TimelineDot variant="outlined">
                        <FormatListNumberedIcon />
                    </TimelineDot>
                    <TimelineConnector />
                </TimelineSeparator>
            )
    }
}
